import React from 'react'
import { Clock, Filter, AlertCircle, Globe, X } from 'lucide-react'

const Problem: React.FC = () => {
  const problems = [
    {
      icon: Clock,
      title: '시간 낭비',
      description: '30분 영상, 핵심은 2분',
      color: 'from-red-500 to-red-600',
      bgColor: 'from-red-50 to-red-100'
    },
    {
      icon: Filter,
      title: '알고리즘 함정',
      description: '늘 비슷한 추천 콘텐츠',
      color: 'from-orange-500 to-orange-600',
      bgColor: 'from-orange-50 to-orange-100'
    },
    {
      icon: AlertCircle,
      title: '뒤늦은 발견',
      description: '이미 대세가 바뀌었다고?',
      color: 'from-yellow-500 to-yellow-600',
      bgColor: 'from-yellow-50 to-yellow-100'
    },
    {
      icon: Globe,
      title: '언어 장벽',
      description: '국외 커뮤니티는 영어라...',
      color: 'from-purple-500 to-purple-600',
      bgColor: 'from-purple-50 to-purple-100'
    }
  ]

  return (
    <section className="section-padding bg-gradient-to-br from-gray-50 to-gray-100 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-br from-red-200/20 to-orange-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-64 h-64 bg-gradient-to-tr from-purple-200/20 to-yellow-200/20 rounded-full blur-3xl"></div>
      </div>

      <div className="container-max relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 rounded-full px-4 py-2 mb-6 fade-in-up">
            <X className="w-4 h-4" />
            <span className="text-sm font-semibold">문제점</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 fade-in-up">
            AI 정보, <span className="text-red-600">이래서 놓칩니다</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto fade-in-up" style={{animationDelay: '0.2s'}}>
            매일 쏟아지는 AI 정보 속에서 진짜 중요한 것만 골라내기 어려우신가요?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className={`group relative bg-gradient-to-br ${problem.bgColor} p-8 rounded-3xl border border-white/50 hover:border-white/80 transition-all duration-500 hover:scale-105 hover:shadow-2xl fade-in-up`}
              style={{animationDelay: `${0.4 + index * 0.2}s`}}
            >
              {/* Hover effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 bg-gradient-to-br ${problem.color} rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <problem.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-gray-800 transition-colors">
                  {problem.title}
                </h3>
                <p className="text-gray-700 text-lg font-medium group-hover:text-gray-600 transition-colors">
                  {problem.description}
                </p>
              </div>

              {/* Decorative elements */}
              <div className="absolute top-4 right-4 w-8 h-8 bg-white/30 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute bottom-4 left-4 w-6 h-6 bg-white/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{transitionDelay: '0.1s'}}></div>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <div className="text-center mt-16 fade-in-up" style={{animationDelay: '1.2s'}}>
          <p className="text-2xl font-bold text-gray-800 mb-4">
            이런 문제들로 인해 <span className="text-red-600">진짜 중요한 AI 트렌드를 놓치고 계시나요?</span>
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-orange-500 rounded-full mx-auto"></div>
        </div>
      </div>
    </section>
  )
}

export default Problem
